module.exports = __webpack_public_path__ + "assets/img/tx180_4.7abf2b9c.jpg";